import { render } from "./Search.vue?vue&type=template&id=0a5a4592&scoped=true"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-0a5a4592"

export default script